import React, { useState } from "react";

// project-imports
import { Link, useParams } from "react-router-dom";
import Image from "../../common/footer/Images/Image";
import Spinner from "../spinner-component/SpinnerOne";
import { formatViews, handleDiscountedPrice, numberFormatter } from "../../utils/course";
import { checkMediaUrl, getThumbnailFromYouTube } from "../../utils";
import ProductRatingData from "../../data/Products/ProductRating.json";
import Layout from "../../common/Layout";
import SEO from "../../common/SEO";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { GoogleAnalyticsEnum } from "../../utils/google-analytics";
import { useProductContext } from "../../context/product_context";
import ProductRating from "../../data/Products/ProductRating.json";
import { calculateAverageRating } from "../../utils/product";

const EBookUserReview = ({ title }) => {
  // Property initialization
  const { productCode, type } = useParams();
  const { ebooks, productsError, productLoading } = useProductContext();

  // constant variable
  const eBookProductCode = productCode || "";
  const data = (ebooks || [])?.filter(
    (ebook) =>
      ebook?.productCode?.trim().toLowerCase() ===
      eBookProductCode?.toLowerCase()
  );
  const ebookItem = data && data[0] && (data[0] || {});

  // const reviews = JSON.stringify(ProductRatingData);
  const reviews =
    ebookItem && ebookItem?.metadata && ebookItem?.metadata?.ratings && ebookItem?.metadata?.ratings !== "0"
      ? ebookItem?.metadata?.ratings
      : "[]";

  // this will remove the tralling commas as there is the comma that making error on pars so used this to clean the string
  let cleanString = reviews?.replace(/,\s*([}\]])/g, "$1");
  const review = JSON.parse(cleanString);

  // variabel for overallRatings
  const overAllAverageRatings = calculateAverageRating(review);

  //RatingSummary
  const buildRatingSummary = (reviews = []) => {
    try {
      const summary = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

      reviews?.forEach((review) => {
        summary[review?.rating] += 1;
      });

      return summary;
    } catch (error) { }
  };
  const ratingSummary = buildRatingSummary(review);
  //constant variabel for totalreviews
  const totalReviews = review?.length;
  //getProgresswidth in rarings
  const getProgressWidth = (count, total) => {
    return total > 0 ? (count / total) * 100 : 0;
  };

  // Dynamic Css for star Rating Start (Added By Longswitch Team)
  const halfIconDynamicStyle = (rating) => {
    let ratings = Number((rating - Math.floor(rating)) * 100).toFixed(2);

    return {
      "--width": `${ratings}%`,
      "--rating-percent": `${100 - ratings}%`,
    };
  };

  return (
    <>

      {productLoading && <Spinner />}
      <SEO
        title="Our Resource User Reviews | Longswitch Academy"
        url={process.env.REACT_APP_META_URL + "e-books"}
      />
      <Layout searchDisable={true}>
        <BreadcrumbOne
          title={ebookItem?.name || "E-Book Review"} // Breadcrumb title
          rootUrl="/"
          parentUrl="Home"
          googleEnum={GoogleAnalyticsEnum.SALESFORCE_COURSE_DETAILS_TO_HOME}
          currentUrl={`Our Resource User Reviews`}
        />
        <div className="container edu-section-gapBottom  bg-color-white">
          <div className="course-details-content tab-content">
            <div className={`tab-pane fade show active `}>
              <div className="course-tab-content">
                <div className="row row--30">
                  <div className="col-lg-4">
                    <div className="rating-box">
                      <div className="rating-number">
                        {overAllAverageRatings}
                      </div>
                      <div className="rating eduvibe-course-rating-stars">
                        {[...Array(5)].map((rate, index) => {
                          const givenRating = index + 1;
                          return (
                            <i
                              className={
                                overAllAverageRatings >= givenRating
                                  ? "icon-Star"
                                  : overAllAverageRatings > givenRating - 1 &&
                                    overAllAverageRatings < givenRating
                                    ? " icon-Star-half "
                                    : " off icon-Star"
                              }
                              key={index}
                              style={halfIconDynamicStyle(
                                overAllAverageRatings
                              )}
                            ></i>
                          );
                        })}
                      </div>
                      <span>({totalReviews} Ratings)</span>
                    </div>
                  </div>

                  <div className="col-lg-8">
                    <div className="review-wrapper">
                      {[5, 4, 3, 2, 1].map((star) => {
                        const count = ratingSummary[star];
                        const width = getProgressWidth(count, totalReviews);

                        return (
                          <div className="single-progress-bar" key={star}>
                            <div className="rating-text">
                              {star} <i className="icon-Star"></i>
                            </div>

                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${width}%` }}
                                aria-valuenow={width}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              />
                            </div>

                            <span className="rating-value">
                              {numberFormatter.format(count)}
                              <span className="rating-persentage">
                                ({width.toFixed(0)}%)
                              </span>
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="comment-wrapper pt--40">
                  <div className="section-title">
                    <h5 className="mb--25">Reviews</h5>
                  </div>
                  {/* Review Section */}
                  {review &&
                    review?.length &&
                    review.map((item, i) => (
                      <div className="edu-comment">
                        <div className="thumbnail">
                          <Link to={item.linkedIn} target="_blank">
                            <img
                              src="/images/course/student-review/linkedin_logo.png"
                              alt="Student Thumb"
                            />
                          </Link>
                        </div>
                        <div className="comment-content">
                          <div className="comment-top">
                            <h6 className="title">
                              {item?.userName || "Guest User"}
                            </h6>
                            <div className="rating eduvibe-course-rating-stars">
                              {/* <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i>
                              <i className="icon-Star"></i> */}
                              {[...Array(5)].map((rate, index) => {
                                const givenRating = index + 1;
                                return (
                                  <i
                                    className={
                                      item?.rating >= givenRating
                                        ? "icon-Star"
                                        : item?.rating > givenRating - 1 &&
                                          item?.rating < givenRating
                                          ? " icon-Star-half "
                                          : " off icon-Star"
                                    }
                                    key={index}
                                    style={halfIconDynamicStyle(item?.rating)}
                                  ></i>
                                );
                              })}
                            </div>
                          </div>
                          {item?.subtitle && (
                            <span className="subtitle">
                              â€œ Outstanding Course â€
                            </span>
                          )}
                          {item?.description && <p>{item?.description}</p>}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default EBookUserReview;
